import { PageHeader } from "@ant-design/pro-components";
import { CopyAllOutlined } from "@mui/icons-material";
import { Alert, Button, Card, Form, Input, message } from "antd";
import { memo, useState } from "react";
import api from "../../../api/api";
import styles from "./SnapppayCancel.module.css";
import { DollarCircleFilled, DollarCircleOutlined } from "@ant-design/icons";

const SnapppayCancel = ({ userData, onLogout }) => {
  const [form] = Form.useForm();

  const [result, setResult] = useState({
    message: "",
    type: "",
  });

  const sendRequest = () => {
    const formData = form.getFieldValue();

    api
      .post("/payment/snapp-pay/cancel", formData)
      .then((res) => {
        setResult({
          message: res.data.message,
          type: res.data.status,
        });
      })
      .catch((error) => {
        let messageText = error.response.data.error.message;
        if (error.response.data.error.message === "INVALID_SOURCE") {
          messageText = "شماره مبدا نامعتبر است";
        } else if (error.response.data.error.message === "INVALID_DESTINATION") {
          messageText = "شماره مقصد نامعتبر است";
        } else if (error.response.data.error.message === "DESTINATION_EXISTS") {
          messageText = "شماره مقصد در حال حاضر وجود دارد";
        }
        message.error(messageText);
        setResult({
          message: messageText,
          type: "error",
        });
      });
  };

  return (
    <div className={styles.CopyRoadmap}>
      <PageHeader title="لغو پرداخت اسنپ پی" avatar={{ icon: <DollarCircleOutlined />, size: "large" }} />

      <Card className={styles.Form}>
        <Form form={form} name="validateOnly" layout="vertical" autoComplete="off">
          <Form.Item
            name="transactionId"
            label="شماره تراکنش"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="token"
            label="توکن"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                sendRequest();
              }}
            >
              لغو پرداخت
            </Button>
          </Form.Item>

          {result.message && <Alert message={result.message} type={result.type} />}
        </Form>
      </Card>
    </div>
  );
};

export default memo(SnapppayCancel);
